export default __webpack_public_path__ + "static/media/schoolGame.12614efd.png";